// src/components/impact/ImpactParityExplanation.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { ContentCard } from '@dopomogai/ui';
import { renderIcon } from '@dopomogai/utils';

interface Point {
  icon: string;
  title: string;
  text: string;
}

interface ExplanationData {
  headline: string;
  corePhilosophy: string;
  howItWorks: {
    title: string;
    points: Point[];
  };
}

interface ImpactParityExplanationProps {
  explanationData: ExplanationData;
}

export const ImpactParityExplanation: React.FC<ImpactParityExplanationProps> = ({ explanationData }) => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{explanationData.headline}</h2>
          <p className="mt-4 text-lg text-slate-600">{explanationData.corePhilosophy}</p>
        </motion.div>

        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">{explanationData.howItWorks.title}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {explanationData.howItWorks.points.map((point, index) => (
              <ContentCard
                key={index}
                index={index}
                hoverEffect="lift"
                icon={renderIcon(point.icon, { size: 24, className: "text-emerald-600" })}
                iconContainerClassName="p-3 bg-emerald-100 border-2 border-black rounded-lg w-fit"
                title={point.title}
                text={point.text}
                titleClassName="text-lg"
                textClassName="text-sm"
                contentClassName="p-6"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

